/*
 * $Id:: index.js 2020/11/10 02:48 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect } from 'react';

const Recaptcha = ({ siteKey, onVerify, recaptchaApproved = false, onRecaptchaError }) => {
    useEffect(() => {
        const handleLoaded = () => {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(`${siteKey}`, { action: 'submit' })
                    .then(() => {
                        onVerify();
                    })
                    .catch(() => {
                        onRecaptchaError();
                    });
            });
        };
        //Add recaptcha if not already approved
        if (!recaptchaApproved) {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
            script.addEventListener('load', handleLoaded);
            document.body.appendChild(script);
        }
    }, []);

    return <div className={'g-recaptcha'} data-size={'invisible'}></div>;
};

export default Recaptcha;
